import React, { FC, PropsWithChildren, useState } from "react";

const ReportContext =
  React.createContext<ReturnType<typeof useReportContextValue> | null>(null);

interface IProps {}
export const ReportContextProvider = ({
  children,
}: React.PropsWithChildren<IProps>) => {
  const value = useReportContextValue();
  return (
    <ReportContext.Provider value={value}>{children}</ReportContext.Provider>
  );
};

const useReportContextValue = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  return {
    isLandscape,
    setIsLandscape,
  };
};

export const useReportContext = () => {
  const value = React.useContext(ReportContext);
  if (!value) {
    throw new Error("ReportContext is not initialized");
  }
  return value;
};
